"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseController_1 = __importDefault(require("./BaseController"));
class UserController extends BaseController_1.default {
    constructor() {
        super();
        this.fetchFeatures = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_feature}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchProfile = (kerbId) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_profile}${kerbId && kerbId !== "" ? `/${kerbId}` : ``}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                try {
                    let data = yield response.json();
                    return {
                        person: {
                            kerberosId: data.kerberos,
                            mitId: data.mitid,
                            firstName: data.first_name,
                            lastName: data.last_name,
                            displayName: data.display_name,
                            email: data.email,
                            phone: data.phone_number,
                            mobile: data.phone_number,
                        },
                    };
                }
                catch (error) {
                    return {
                        person: {
                            kerberosId: "",
                            mitId: "",
                            firstName: "",
                            lastName: "",
                            displayName: "",
                            email: "",
                            phone: "",
                            mobile: "",
                        },
                    };
                }
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchPicture = (mitId, highResolution) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_picture}${mitId ? `/${mitId}${highResolution ? "?resolution=high" : ""}` : ""}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.blob();
                return {
                    value: URL.createObjectURL(data),
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.url_picture = `${this.apiHost}/${this.apiPathDigitalId}/picture`;
        this.url_profile = `${this.apiHost}/${this.apiPathDigitalId}/profile`;
        this.url_feature = `${this.apiHost}/${this.apiPathPass}/pass/features`;
    }
}
const userController = new UserController();
exports.default = userController;
